export var Paths;

(function (Paths) {
  Paths["GoogleLogin"] = "/auth/google";
  Paths["DeviceClaim"] = "/devices/claim";
  Paths["DeviceInfo"] = "/devices/info?token=:token";
})(Paths || (Paths = {}));